// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { LlmPricingOperationsService } from '../generated/api/llmPricingOperations.service';

@Injectable({ providedIn: 'root' })
export class LlmPricingOperationsClientService {
  constructor(private readonly client: LlmPricingOperationsService) {}
  // <generated-client-wrappers:methods>
  current(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreditPricingVersion> {
    if (!this.client)
      throw new Error('LlmPricingOperationsService is not available');
    return this.client.llmPricingOperationsCurrent(
      'body',
      reportProgress,
      options,
    );
  }

  providerPrice(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ProviderPriceDetails> {
    if (!this.client)
      throw new Error('LlmPricingOperationsService is not available');
    return this.client.llmPricingOperationsProviderPrice(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  providerPrices(
    provider?: string,
    search?: string,
    page?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ProviderPricePage> {
    if (!this.client)
      throw new Error('LlmPricingOperationsService is not available');
    return this.client.llmPricingOperationsProviderPrices(
      provider,
      search,
      page,
      'body',
      reportProgress,
      options,
    );
  }

  publish(
    request: WrapperApi.CreditPricingPublication,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PricingPublicationReceipt> {
    if (!this.client)
      throw new Error('LlmPricingOperationsService is not available');
    return this.client.llmPricingOperationsPublish(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  publishProviderPrice(
    request: WrapperApi.ProviderPricePublication,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ProviderPricePublicationReceipt> {
    if (!this.client)
      throw new Error('LlmPricingOperationsService is not available');
    return this.client.llmPricingOperationsPublishProviderPrice(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  version(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreditPricingVersion> {
    if (!this.client)
      throw new Error('LlmPricingOperationsService is not available');
    return this.client.llmPricingOperationsVersion(
      id,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
